export default __webpack_public_path__ + "static/media/Golder-Logo.a6955762.jpg";